<script>
import { Line, mixins } from 'vue-chartjs'
import common from '../../../../common.js'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData'],
  data: function() {
    return {
      options: {
        devicePixelRatio: 1,
        responsive: true,
        scaleOverride: true,
        scaleSteps: 6,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
          custom: function(tooltip, data) {
            let tooltipEl = document.getElementById('chartjs-tooltip');
            // 最初の表示時に要素を生成
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              this._chart.canvas.parentNode.appendChild(tooltipEl);
            }

            if (tooltip.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            const dp = tooltip.dataPoints[0];
            const arrival = this._data.datasets[3].data[dp.index];
            const offrate = parseInt(this._data.datasets[4].data[dp.index] * 100);

            let act_msg = '';
            let pre_msg = '';
            let cus_msg = '';

            // 実績が存在する場合は、予測を表示しない
            const act_sales = this._data.datasets[0].data[dp.index];
            if (act_sales) {
              act_msg = '実績販売数: ' + common.separate_every_3digits(act_sales) + '<br>' +
                '実績在庫数: ' + common.separate_every_3digits(arrival - act_sales) + '<br>' +
                '実績消化率: ' + common.separate_every_3digits(parseFloat(Number(act_sales / arrival * 100).toFixed(1))) + '%<br>';
            } else {
              // 予測
              let pre_sales = this._data.datasets[1].data[dp.index];
              if (pre_sales) {

                // 小数点 第4までにする (API の res は 小数点第4 なのになぜか増えるから対応)
                pre_sales = pre_sales * 10000;
                pre_sales = Math.round(pre_sales);
                pre_sales = pre_sales / 10000;

                let pre_stock = arrival - pre_sales
                pre_stock = pre_stock * 10000;
                pre_stock = Math.round(pre_stock);
                pre_stock = pre_stock / 10000;

                pre_msg = '予測販売数: ' + common.separate_every_3digits(pre_sales) + '<br>' +
                  '予測在庫数: ' + common.separate_every_3digits(pre_stock) + '<br>' +
                  '予測消化率: ' + common.separate_every_3digits(parseFloat(Number(pre_sales / arrival * 100).toFixed(1))) + '%<br>';
              }

              // カスタム
              let cus_sales = this._data.datasets[2].data[dp.index];
              if (cus_sales) {

                // 小数点 第4までにする (API の res は 小数点第4 なのになぜか増えるから対応)
                cus_sales = cus_sales * 10000;
                cus_sales = Math.round(cus_sales);
                cus_sales = cus_sales / 10000;

                let cus_stock = arrival - cus_sales
                cus_stock = cus_stock * 10000;
                cus_stock = Math.round(cus_stock);
                cus_stock = cus_stock / 10000;

                cus_msg = 'ｶｽﾀﾑ販売数: ' + common.separate_every_3digits(cus_sales) + '<br>' +
                  'ｶｽﾀﾑ在庫数: ' + common.separate_every_3digits(cus_stock) + '<br>' +
                  'ｶｽﾀﾑ消化率: ' + common.separate_every_3digits(parseFloat(Number(cus_sales / arrival * 100).toFixed(1))) + '%<br>';
              }
            }

            if (tooltip.body) {
              tooltipEl.innerHTML = '入　荷　数: ' + common.separate_every_3digits(arrival) + '<br>' +
                '値　引　率: ' + offrate + '%<br>' +
                act_msg + pre_msg + cus_msg;
            }

            // 画面のスクロール位置からツールチップを右に出すか左に出すか調整
            const chart_area = document.getElementById('chart-area');
            let x = 20;
            const dis_x = parseInt(tooltip.caretX - chart_area.scrollLeft);
            if (dis_x >= 350) {
              x = -130;
            }
            let y = parseInt(tooltipEl.clientHeight / 2);
            const dis_y = tooltip.caretY - y;
            if (dis_y <= 0) {
              y = 0;
            }

            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = (tooltip.caretX + x) + 'px';
            tooltipEl.style.top = (tooltip.caretY - y) + 'px';
          }
        },
        elements: {
          line: {
            tension: 0,
            fill: false,
            backGroundColor: 'rgba(0,0,0,0.0)',
            borderWidth: 4,
          },
          point: {
            pointStyle: 'circle',
            radius: 4,
            hitRadius: 8,
            hoverRadius: 4,
          },
        },
        animation: {
          onComplete: (animation) => {
            this.$emit('render', this.$data._chart);
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              callback: (value, index, values) => {
                if (index % 7 == 0 && index > 1) {
                  return value;
                } else {
                  return null;
                }
              },
              minRotation: 0,
              maxRotation: 0
            }
          }],
          yAxes: [{
            ticks: {
              min: 0,
              callback: (label, index, labels) => {
                // 整数値のみ桁数を区切って表示
                if (Math.round(label) === label) {
                  return common.separate_every_3digits(label);
                } else {
                  return null;
                }
              },
              suggestedMax: 10,
            },
          }],
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
}
</script>



// WEBPACK FOOTER //
// simulatechart.vue?2681ea7e